
export default {
  appTitle: 'Stayin Office',
  defaultCurrency: 'EUR'
};
